import _ from 'lodash';

import { MultiChipSelect } from 'ui';

interface Props {
  selectedOptionKeys: Array<string | number>;
  allOptionGroups: SelectOption[][];
  onChange(changedOption: SelectOption): void;
  inputLabel: string;
  id: string;
}

const SelectedOptionsList = ({
  allOptionGroups,
  selectedOptionKeys,
  onChange,
  inputLabel,
  id,
}: Props) => {
  const allOptions = _.concat([], ...allOptionGroups);
  const allSelectOptionsByKey = _.keyBy(allOptions, 'key');
  const selectedOptions = selectedOptionKeys.map(
    (selectedOptionKey) => allSelectOptionsByKey[selectedOptionKey]
  );

  const handleChange = (item: SelectOption) => {
    onChange(item);
  };

  return (
    <div className="SelectedOptionsList">
      <MultiChipSelect
        onChange={handleChange}
        itemGroups={allOptionGroups}
        selectedItems={selectedOptions}
        inputLabel={inputLabel}
        id={id}
      />
    </div>
  );
};

export default SelectedOptionsList;
